import { useState, useEffect } from 'react';
import { getAllBeneficiaries, toggleBeneficiaryStatus } from '../../services/api';

export default function Users() {
  const [users, setUsers]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');
  const [confirm, setConfirm] = useState(null);
  const [toast, setToast]     = useState('');

  const showToast = msg => { setToast(msg); setTimeout(()=>setToast(''),3000); };

  useEffect(()=>{ load(); },[]);

  const load = async () => {
    try { const data = await getAllBeneficiaries(); setUsers(data); }
    catch(err) { showToast('Failed: '+err.message); }
    finally { setLoading(false); }
  };

  const handleToggle = async (id) => {
    try {
      const res = await toggleBeneficiaryStatus(id);
      setUsers(u=>u.map(x=>x.id===id?{...x,isActive:res.isActive}:x));
      showToast(res.message);
    } catch(err) { showToast('Error: '+err.message); }
    setConfirm(null);
  };

  const filtered = users.filter(u=>u.user?.fullName?.toLowerCase().includes(search.toLowerCase())||u.user?.email?.toLowerCase().includes(search.toLowerCase())||String(u.id).includes(search));

  return (
    <div>
      {toast && <div style={{ position:'fixed', top:72, right:24, zIndex:999, background:'#1f2937', color:'white', padding:'12px 20px', borderRadius:10, fontSize:13, fontWeight:600 }}>{toast}</div>}
      {confirm && (
        <div style={{ position:'fixed', inset:0, zIndex:998, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center' }}>
          <div style={{ background:'white', borderRadius:12, padding:28, maxWidth:360, width:'100%', boxShadow:'0 20px 60px rgba(0,0,0,0.25)' }}>
            <h3 style={{ fontSize:16, fontWeight:800, margin:'0 0 10px', textAlign:'center' }}>Confirm?</h3>
            <p style={{ color:'var(--text-secondary)', fontSize:13, textAlign:'center', margin:'0 0 20px' }}>{confirm.action} <strong>{confirm.name}</strong>?</p>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={()=>handleToggle(confirm.id)} style={{ flex:1, padding:11, background:confirm.action==='Deactivate'?'#ef4444':'#10b981', color:'white', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer' }}>Confirm</button>
              <button onClick={()=>setConfirm(null)} style={{ flex:1, padding:11, background:'var(--bg-light)', border:'1px solid var(--border-light)', borderRadius:8, fontWeight:600, cursor:'pointer' }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(150px,1fr))', gap:14, marginBottom:22 }}>
        {[['Total',users.length,'#0066cc'],['Active',users.filter(u=>u.isActive).length,'#10b981'],['Inactive',users.filter(u=>!u.isActive).length,'#6b7280']].map(([l,v,c])=>(
          <div key={l} style={{ background:'white', padding:'16px 18px', borderRadius:10, boxShadow:'0 2px 8px rgba(0,0,0,0.07)' }}>
            <p style={{ color:'var(--text-secondary)', fontSize:12, margin:'0 0 4px' }}>{l}</p>
            <h3 style={{ fontSize:24, fontWeight:800, margin:0, color:c }}>{v}</h3>
          </div>
        ))}
      </div>
      <div style={{ display:'flex', gap:10, marginBottom:18 }}>
        <input type="text" placeholder="Search name, email or ID..." value={search} onChange={e=>setSearch(e.target.value)} style={{ flex:1, padding:'10px 14px', border:'1.5px solid var(--border-light)', borderRadius:8, fontSize:14 }}/>
        <button onClick={load} style={{ padding:'10px 20px', background:'var(--primary-color)', color:'white', border:'none', borderRadius:8, fontWeight:700, fontSize:13, cursor:'pointer' }}>Refresh</button>
      </div>
      {loading ? <div style={{ textAlign:'center', padding:60, color:'var(--text-secondary)' }}>Loading...</div> : (
        <div style={{ background:'white', borderRadius:12, boxShadow:'0 2px 8px rgba(0,0,0,0.07)', overflow:'hidden' }}>
          <div style={{ overflowX:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
              <thead><tr style={{ background:'var(--bg-light)' }}>
                {['ID','Name','National ID','County','Category','Status','Actions'].map(h=><th key={h} style={{ padding:'10px 14px', textAlign:'left', fontWeight:700, color:'var(--text-secondary)', fontSize:11, textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>)}
              </tr></thead>
              <tbody>
                {filtered.map(u=>(
                  <tr key={u.id} style={{ borderBottom:'1px solid var(--border-light)' }}>
                    <td style={{ padding:'12px 14px', fontFamily:'monospace', fontSize:12, color:'#0066cc', fontWeight:700 }}>IJ-{u.id}</td>
                    <td style={{ padding:'12px 14px' }}><div style={{ fontWeight:700 }}>{u.user?.fullName||'�'}</div><div style={{ fontSize:11, color:'var(--text-light)' }}>{u.user?.email||'�'}</div></td>
                    <td style={{ padding:'12px 14px', color:'var(--text-secondary)', fontSize:12 }}>{u.nationalId||'�'}</td>
                    <td style={{ padding:'12px 14px', color:'var(--text-secondary)' }}>{u.county||'�'}</td>
                    <td style={{ padding:'12px 14px', color:'var(--text-secondary)', fontSize:12 }}>{u.category||'�'}</td>
                    <td style={{ padding:'12px 14px' }}>
                      <span style={{ background:u.isActive?'#d1fae5':'#f3f4f6', color:u.isActive?'#065f46':'#6b7280', borderRadius:20, padding:'3px 10px', fontSize:11, fontWeight:700 }}>{u.isActive?'Active':'Inactive'}</span>
                    </td>
                    <td style={{ padding:'12px 14px' }}>
                      <div style={{ display:'flex', gap:6 }}>
                        <button onClick={()=>showToast('Credentials resent to '+u.user?.email)} style={{ padding:'5px 10px', background:'#eff6ff', color:'#0066cc', border:'1px solid #bfdbfe', borderRadius:6, fontSize:11, fontWeight:700, cursor:'pointer' }}>Resend</button>
                        <button onClick={()=>setConfirm({ id:u.id, name:u.user?.fullName, action:u.isActive?'Deactivate':'Activate' })} style={{ padding:'5px 10px', background:u.isActive?'#fee2e2':'#d1fae5', color:u.isActive?'#7f1d1d':'#065f46', border:'1px solid '+(u.isActive?'#fca5a5':'#6ee7b7'), borderRadius:6, fontSize:11, fontWeight:700, cursor:'pointer' }}>
                          {u.isActive?'Deactivate':'Activate'}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {filtered.length===0 && <tr><td colSpan={7} style={{ padding:32, textAlign:'center', color:'var(--text-light)' }}>No beneficiaries found</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}


